export const SHIFT_TYPES = [
  "WORK",
  "REGULAR",
  "TRANSFER",
  "PRESENCE",
  "MEETING",
  "BREAK",
  "ABSENCE",
] as const;

export type ShiftType = (typeof SHIFT_TYPES)[number];

export interface Schedule {
  id: string;
  shiftId?: string;
  coworkerEmail: string;
  scheduleDate: number;
  shiftStartTime: number;
  shiftEndTime: number;
  shiftType?: string;
  activity?: string;
  editedAt?: string;
  editedBy?: string;
}

export type ScheduleUpdate = Pick<Schedule, "activity" | "shiftType"> & {
  shiftStartTime?: string;
  shiftEndTime?: string;
  coworkerEmail?: string;
};
